import { t } from "@/i18n-js/instance";
import type { Plan } from "@circle-react/types";
import { Typography } from "@circle-react-uikit/Typography";
import { PlanFeature } from "../PlanDetails/PlanFeature";
import { BillingCurrency } from "./BillingCurrency";
import { BillingCycle } from "./BillingCycle";
import { PlanHeaders } from "./PlanHeaders";
import { TopSection } from "./TopSection";

interface PlanProps {
  plans: Plan[];
}

export const PlansMobile = ({ plans }: PlanProps) => {
  const isAnnualFeatureAvailable = (plan: any) =>
    plan.tier !== "basic" && plan.tier !== "professional";

  const PLAN_FEATURES: any = {
    basic: { total: 8, total_annual: 0 },
    professional: { total: 9, total_annual: 0 },
    business: { total: 9, total_annual: 1 },
    enterprise: { total: 8, total_annual: 3 },
  };

  const featureKey = "feature_";
  const annualFeatureKey = "annual_feature_";

  const renderFeatureList = (
    planName: string,
    total: number,
    featureKey: string,
  ) =>
    Array.from({ length: total }).map((_, index) => (
      <div className="mb-1" key={`${planName}-${featureKey}${index + 1}`}>
        <PlanFeature
          count={t(
            `pricing_plans.main_features.${planName}.${featureKey}${index + 1}`,
          )}
        />
      </div>
    ));

  return (
    <div className="pb-12">
      <TopSection />
      <BillingCycle />
      <BillingCurrency />
      {plans.map((plan: Plan) => (
        <div
          key={plan.id}
          className="bg-primary border-primary mb-4 rounded border p-4"
        >
          <PlanHeaders plan={plan} />
          <div className="my-4">
            <Typography.LabelMd weight="semibold">
              {t(`pricing_plans.main_features.title.${plan.tier}`)}
            </Typography.LabelMd>
          </div>
          {renderFeatureList(
            plan.tier,
            PLAN_FEATURES[plan.tier].total,
            featureKey,
          )}
          {isAnnualFeatureAvailable(plan) && (
            <>
              <div className="mb-3">
                <Typography.LabelMd weight="semibold">
                  {t("pricing_plans.annual_plan_only")}
                </Typography.LabelMd>
              </div>
              {renderFeatureList(
                plan.tier,
                PLAN_FEATURES[plan.tier].total_annual,
                annualFeatureKey,
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};
